import { useContext } from 'react';

import { StepOne, StepTwo, StepThree, StepFour } from '../Steps';

import {
  GenericDataFormProvider,
  StepOneFormProvider,
} from '../../shared/contexts';
import { QuotationInfoContext } from '../../shared/contexts/QuotationInfo';
import { StepFourFormProvider } from '../Steps/StepFour/components/Form/contexts/StepFourForm';
import { StepThreeFormProvider } from '../Steps/StepThree/contexts/StepThreeForm';
import { StepTwoFormProvider } from '../Steps/StepTwo/contexts/StepTwoForm';
import { WizardDataFormProvider } from './contexts/WizardDataForm';

import { QuotationStep } from '../../shared/interfaces';
import { LoadSavedQuotation } from '../components/LoadSavedQuotation';
import { RenewalHomeQuotation } from '../components/RenewalHomeQuotation';

export const WizardHome = () => {
  const { currentStep, loadingSavedQuotation, loadingRenewalQuotation } = useContext(QuotationInfoContext);

  const getStepComponent = () => {
    switch (currentStep) {
      case QuotationStep.ONE:
        return <StepOne />;
      case QuotationStep.TWO:
        return <StepTwo />;
      case QuotationStep.THREE:
        return <StepThree />;
      case QuotationStep.FOUR:
        return <StepFour />;
      default:
        break;
    }
  };

  return (
    <StepOneFormProvider>
      <WizardDataFormProvider>
        <StepTwoFormProvider>
          <StepThreeFormProvider>
            <StepFourFormProvider>
                { loadingRenewalQuotation ? <RenewalHomeQuotation /> : loadingSavedQuotation ? <LoadSavedQuotation /> : getStepComponent() }
            </StepFourFormProvider>
          </StepThreeFormProvider>
        </StepTwoFormProvider>
      </WizardDataFormProvider>
    </StepOneFormProvider>
  );
};
